import { AppState, WidgetPagePhillyAppState } from '../../../initialStateRegistration';

const getWidgetPage = (state: AppState) => (state as WidgetPagePhillyAppState).template;

export const getMetadataDescription = (state: AppState) => getWidgetPage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getWidgetPage(state).metadataTitle;

export const getMetadataImage = (state: AppState) => getWidgetPage(state).metadataImage;

export const getSportradarProps = (state: AppState) => getWidgetPage(state).sportradarProps;

export const getOutbrainWidgetID = (state: AppState) => getWidgetPage(state).outbrainWidgetID;

export const getShowRecommendationsAdvertisement = (state: AppState) => getWidgetPage(state).showRecommendationsAdvertisement;
